// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .AboutMe {
    background: rgb(253, 29, 29);
    background: radial-gradient(
      circle,
      rgb(23, 2, 104) 50%,
      rgb(15, 2, 49) 100%
    );
    color: white;
    font-family: sans-serif;
    text-align: center;
  }
  
  .h21 {
    margin-top: -14%;
    color: rgb(254, 0, 182);
    left: calc(25%);
    font-size: 6.5vh;
    font-weight: 700;
    font-family: sofia-pro, sans-serif;
    font-style: normal;
    letter-spacing: -.0001em;
    line-height: 1.2em;
    position: absolute;
  }
  .h41{
    margin-top: 0%;
    color: rgb(203, 198, 206);
    left: calc(23%);
    right: calc(-70%);
    font-size: 2.5vh;
    position: absolute;
    max-width: 22%;
    line-height: 1.2em;
  }
  .h22 {
    margin-top: -14%;
    color: rgb(254, 0, 119);
    left: calc(20%);
    font-size: 6.5vh;
    font-weight: 700;
    font-family: sofia-pro, sans-serif;
    font-style: normal;
    letter-spacing: -.0001em;
    line-height: 1.2em;
    position: absolute;
  }
  .h42{
    margin-top: -15%;
    color: rgb(196, 184, 203);
    margin-left: -10%;
    font-size: 2.5vh;
    position: absolute;
    line-height: 1.2em;
    width: 125%;
  }
  .h23 {
    margin-top: -14%;
    color: rgb(254, 0, 119);
    left: calc(20%);
    font-size: 6.5vh;
    font-weight: 700;
    font-family: sofia-pro, sans-serif;
    font-style: normal;
    letter-spacing: -.0001em;
    line-height: 1.2;
    position: absolute;
  }
  .h43{
    margin-top: -15%;
    color: rgb(196, 184, 203);
    margin-left: -10%;
    font-size: 2.5vh;
    position: absolute;
    line-height: 1.2em;
    width: 118%;
  }
  .h24 {
    margin-top: -14%;
    color: rgb(254, 0, 119);
    left: calc(20%);
    font-size: 6.5vh;
    font-weight: 700;
    font-family: sofia-pro, sans-serif;
    font-style: normal;
    letter-spacing: -.0001em;
    line-height: 1.2;
    position: absolute;
  }
  .h44{
    margin-top: -15%;
    color: rgb(196, 184, 203);
    margin-left: -10%;
    font-size: 2.5vh;
    position: absolute;
    width: 125%;
    justify-content:left!important;
    line-height: 1.2em;

  }
  
  .img1, .img2, .img3, .img4 {
    left: calc(50%);
    width: 50vh;
    position: absolute;
    max-height: 250%;
  }
  
  .section1 {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    scroll-snap-align: center;
    perspective: 500px;
  }
  
  .section1 > div {
    width: 315px;
    height: 400px;
    position: relative;
    max-height: 90vh;
    margin: 20px;
    border-radius: 5px;
  }

  .progress-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 15px;
    background: linear-gradient(to right, #ff0099,#ff00cc,#cc00ff,#8d01ff);
    transform-origin: 0%;
    z-index: 100000000000000000000000!important;
    overflow: visible!important;
  }

  @media all and (max-width: 1024px) {
    .h21{
        left: 15%;
        margin-top: -15%;
    }
    .h41{
        left: 15%;
        margin-top: 5%;
    }
    .h22{
        left:14%;
        margin-top: -33%;
    }
    .h23{
        left: 10%;
        margin-top: -25%;
    }
    .h24{
        left: 15%;
        margin-top: -20%;
    }
  }
  @media all and (max-width: 768px) {
    .img1, .img2, .img3, .img4{
        left:-25%;
        margin-top: 50%;
        width: 150%;
    }
    .img2{
        margin-top: 50%!important;
    }
    .img3{
        margin-top: 95%!important;
        max-height: 100%;
        max-width: 100%;
        left: 0%;
    }
    .img4{
        margin-top: 85%!important;
        max-width: 100%;
        left: 0%;
    }
    .h41{
        min-width: 500px;
        max-width: 500px;
        margin-top: -10%;
        left: 17%;
    }
    .h21{
        margin-top: -35%;
        left: 33%;
    }
    .h22{
        margin-top: -125%;
        left: 30%;
    }
    .h23{
        margin-top: -115%;
        left:27.5%;
    }
    .h24{
        margin-top: -100%;
        left: 33%;;
    }
    .section1{
        margin-bottom: 30%;
    }
  }

  @media all and (max-width: 425px) {
    .img1, .img2, .img3, .img4{
        left:-5.5%;
        margin-top: 50%;
        width: 110%;
    }
    .img2{
        margin-top: 50%!important;
    }
    .img3{
        margin-top: 95%!important;
        max-height: 100%;
        max-width: 100%;
        left: 0%;
    }
    .img4{
        margin-top: 85%!important;
        max-width: 100%;
        left: 0%;
    }
    .h41{
        min-width: 300px;
        max-width: 350px;
        margin-top: -50%;
        left: 9%;
    }
    .h21{
        margin-top: -105%;
        left: 23%;
    }
    .h22{
        min-width: 250px;
        max-width: 300px;
        margin-top: -225%;
        left: 13%;
    }
    .h23{
        min-width: 250px;
        max-width: 300px;
        margin-top: -225%;
        left:15.5%;
    }
    .h24{
        min-width: 250px;
        max-width: 300px;
        margin-top: -150%;
        left: 20%;;
    }
    .section1{
        margin-bottom: 30%;
    }
  }

  @media all and (max-width: 375px) {
    .img1, .img2, .img3, .img4{
        left:-5.5%;
        margin-top: 50%;
        width: 110%;
    }
    .img2{
        margin-top: 50%!important;
    }
    .img3{
        margin-top: 95%!important;
        max-height: 100%;
        max-width: 100%;
        left: 0%;
    }
    .img4{
        margin-top: 85%!important;
        max-width: 100%;
        left: 0%;
    }
    .h41{
        min-width: 300px;
        max-width: 335px;
        margin-top: -50%;
        left: 4%;
    }
    .h21{
        margin-top: -105%;
        left: 23%;
    }
    .h22{
        width: 335px;
        margin-top: -255%;
        left: 11%;
    }
    .h42{
        width: 335px;
        font-size: 2.35vh;
    }
    .h23{
        min-width: 250px;
        max-width: 300px;
        margin-top: -255%;
        left:11.5%;
    }
    .h43{
        width: 335px;
        font-size: 2.35vh;
    }
    .h24{
        min-width: 250px;
        max-width: 300px;
        margin-top: -150%;
        left: 15%;
    }
    .h44{
        font-size: 2.35vh;
    }
    .section1{
        margin-bottom: 30%;
    }
  }

  @media all and (max-width: 336px) {
    .img1, .img2, .img3, .img4{
        left:-.5%;
        margin-top: 50%;
        width: 100%;
    }
    .img2{
        margin-top: 50%!important;
    }
    .img3{
        margin-top: 95%!important;
        max-height: 100%;
        max-width: 100%;
        left: 0%;
    }
    .img4{
        margin-top: 85%!important;
        max-width: 100%;
        left: 0%;
    }
    .h41{
        min-width: 300px;
        max-width: 300px;
        margin-top: -75%;
        left: 4%;
    }
    .h21{
        margin-top: -155%;
        left: 13%;
    }
    .h22{
        width: 300px;
        margin-top: -350%;
        left: 4%;
    }
    .h42{
        width: 300px;
        margin-left: 0%;
    }
    .h23{
        min-width: 250px;
        max-width: 300px;
        margin-top: -350%;
        left:4%;
    }
    .h43{
        width: 300px;
        margin-left: 0%;
        font-size: 2.35vh;
    }
    .h24{
        min-width: 250px;
        max-width: 300px;
        margin-top: -200%;
        left: 10%;
    }
    .h44{
        width: 300px;
        font-size: 2.35vh;
    }
    .section1{
        margin-bottom: 30%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/AboutMe.css"],"names":[],"mappings":";;EAEE;IACE,4BAA4B;IAC5B;;;;KAIC;IACD,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,sEAAsE;IACtE,oBAAoB;IACpB,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA;IACE;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,cAAc;IAClB;IACA;QACI,QAAQ;QACR,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;EACF;EACA;IACE;QACI,SAAS;QACT,eAAe;QACf,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,kBAAkB;IACtB;EACF;;EAEA;IACE;QACI,UAAU;QACV,eAAe;QACf,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,QAAQ;IACZ;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,kBAAkB;IACtB;EACF;;EAEA;IACE;QACI,UAAU;QACV,eAAe;QACf,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,QAAQ;IACZ;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;EACF;;EAEA;IACE;QACI,SAAS;QACT,eAAe;QACf,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,yBAAyB;QACzB,eAAe;QACf,QAAQ;IACZ;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,QAAQ;IACZ;IACA;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,QAAQ;IACZ;IACA;QACI,YAAY;QACZ,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,OAAO;IACX;IACA;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;EACF","sourcesContent":["\n  \n  .AboutMe {\n    background: rgb(253, 29, 29);\n    background: radial-gradient(\n      circle,\n      rgb(23, 2, 104) 50%,\n      rgb(15, 2, 49) 100%\n    );\n    color: white;\n    font-family: sans-serif;\n    text-align: center;\n  }\n  \n  .h21 {\n    margin-top: -14%;\n    color: rgb(254, 0, 182);\n    left: calc(25%);\n    font-size: 6.5vh;\n    font-weight: 700;\n    font-family: sofia-pro, sans-serif;\n    font-style: normal;\n    letter-spacing: -.0001em;\n    line-height: 1.2em;\n    position: absolute;\n  }\n  .h41{\n    margin-top: 0%;\n    color: rgb(203, 198, 206);\n    left: calc(23%);\n    right: calc(-70%);\n    font-size: 2.5vh;\n    position: absolute;\n    max-width: 22%;\n    line-height: 1.2em;\n  }\n  .h22 {\n    margin-top: -14%;\n    color: rgb(254, 0, 119);\n    left: calc(20%);\n    font-size: 6.5vh;\n    font-weight: 700;\n    font-family: sofia-pro, sans-serif;\n    font-style: normal;\n    letter-spacing: -.0001em;\n    line-height: 1.2em;\n    position: absolute;\n  }\n  .h42{\n    margin-top: -15%;\n    color: rgb(196, 184, 203);\n    margin-left: -10%;\n    font-size: 2.5vh;\n    position: absolute;\n    line-height: 1.2em;\n    width: 125%;\n  }\n  .h23 {\n    margin-top: -14%;\n    color: rgb(254, 0, 119);\n    left: calc(20%);\n    font-size: 6.5vh;\n    font-weight: 700;\n    font-family: sofia-pro, sans-serif;\n    font-style: normal;\n    letter-spacing: -.0001em;\n    line-height: 1.2;\n    position: absolute;\n  }\n  .h43{\n    margin-top: -15%;\n    color: rgb(196, 184, 203);\n    margin-left: -10%;\n    font-size: 2.5vh;\n    position: absolute;\n    line-height: 1.2em;\n    width: 118%;\n  }\n  .h24 {\n    margin-top: -14%;\n    color: rgb(254, 0, 119);\n    left: calc(20%);\n    font-size: 6.5vh;\n    font-weight: 700;\n    font-family: sofia-pro, sans-serif;\n    font-style: normal;\n    letter-spacing: -.0001em;\n    line-height: 1.2;\n    position: absolute;\n  }\n  .h44{\n    margin-top: -15%;\n    color: rgb(196, 184, 203);\n    margin-left: -10%;\n    font-size: 2.5vh;\n    position: absolute;\n    width: 125%;\n    justify-content:left!important;\n    line-height: 1.2em;\n\n  }\n  \n  .img1, .img2, .img3, .img4 {\n    left: calc(50%);\n    width: 50vh;\n    position: absolute;\n    max-height: 250%;\n  }\n  \n  .section1 {\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    scroll-snap-align: center;\n    perspective: 500px;\n  }\n  \n  .section1 > div {\n    width: 315px;\n    height: 400px;\n    position: relative;\n    max-height: 90vh;\n    margin: 20px;\n    border-radius: 5px;\n  }\n\n  .progress-bar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 15px;\n    background: linear-gradient(to right, #ff0099,#ff00cc,#cc00ff,#8d01ff);\n    transform-origin: 0%;\n    z-index: 100000000000000000000000!important;\n    overflow: visible!important;\n  }\n\n  @media all and (max-width: 1024px) {\n    .h21{\n        left: 15%;\n        margin-top: -15%;\n    }\n    .h41{\n        left: 15%;\n        margin-top: 5%;\n    }\n    .h22{\n        left:14%;\n        margin-top: -33%;\n    }\n    .h23{\n        left: 10%;\n        margin-top: -25%;\n    }\n    .h24{\n        left: 15%;\n        margin-top: -20%;\n    }\n  }\n  @media all and (max-width: 768px) {\n    .img1, .img2, .img3, .img4{\n        left:-25%;\n        margin-top: 50%;\n        width: 150%;\n    }\n    .img2{\n        margin-top: 50%!important;\n    }\n    .img3{\n        margin-top: 95%!important;\n        max-height: 100%;\n        max-width: 100%;\n        left: 0%;\n    }\n    .img4{\n        margin-top: 85%!important;\n        max-width: 100%;\n        left: 0%;\n    }\n    .h41{\n        min-width: 500px;\n        max-width: 500px;\n        margin-top: -10%;\n        left: 17%;\n    }\n    .h21{\n        margin-top: -35%;\n        left: 33%;\n    }\n    .h22{\n        margin-top: -125%;\n        left: 30%;\n    }\n    .h23{\n        margin-top: -115%;\n        left:27.5%;\n    }\n    .h24{\n        margin-top: -100%;\n        left: 33%;;\n    }\n    .section1{\n        margin-bottom: 30%;\n    }\n  }\n\n  @media all and (max-width: 425px) {\n    .img1, .img2, .img3, .img4{\n        left:-5.5%;\n        margin-top: 50%;\n        width: 110%;\n    }\n    .img2{\n        margin-top: 50%!important;\n    }\n    .img3{\n        margin-top: 95%!important;\n        max-height: 100%;\n        max-width: 100%;\n        left: 0%;\n    }\n    .img4{\n        margin-top: 85%!important;\n        max-width: 100%;\n        left: 0%;\n    }\n    .h41{\n        min-width: 300px;\n        max-width: 350px;\n        margin-top: -50%;\n        left: 9%;\n    }\n    .h21{\n        margin-top: -105%;\n        left: 23%;\n    }\n    .h22{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -225%;\n        left: 13%;\n    }\n    .h23{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -225%;\n        left:15.5%;\n    }\n    .h24{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -150%;\n        left: 20%;;\n    }\n    .section1{\n        margin-bottom: 30%;\n    }\n  }\n\n  @media all and (max-width: 375px) {\n    .img1, .img2, .img3, .img4{\n        left:-5.5%;\n        margin-top: 50%;\n        width: 110%;\n    }\n    .img2{\n        margin-top: 50%!important;\n    }\n    .img3{\n        margin-top: 95%!important;\n        max-height: 100%;\n        max-width: 100%;\n        left: 0%;\n    }\n    .img4{\n        margin-top: 85%!important;\n        max-width: 100%;\n        left: 0%;\n    }\n    .h41{\n        min-width: 300px;\n        max-width: 335px;\n        margin-top: -50%;\n        left: 4%;\n    }\n    .h21{\n        margin-top: -105%;\n        left: 23%;\n    }\n    .h22{\n        width: 335px;\n        margin-top: -255%;\n        left: 11%;\n    }\n    .h42{\n        width: 335px;\n        font-size: 2.35vh;\n    }\n    .h23{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -255%;\n        left:11.5%;\n    }\n    .h43{\n        width: 335px;\n        font-size: 2.35vh;\n    }\n    .h24{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -150%;\n        left: 15%;\n    }\n    .h44{\n        font-size: 2.35vh;\n    }\n    .section1{\n        margin-bottom: 30%;\n    }\n  }\n\n  @media all and (max-width: 336px) {\n    .img1, .img2, .img3, .img4{\n        left:-.5%;\n        margin-top: 50%;\n        width: 100%;\n    }\n    .img2{\n        margin-top: 50%!important;\n    }\n    .img3{\n        margin-top: 95%!important;\n        max-height: 100%;\n        max-width: 100%;\n        left: 0%;\n    }\n    .img4{\n        margin-top: 85%!important;\n        max-width: 100%;\n        left: 0%;\n    }\n    .h41{\n        min-width: 300px;\n        max-width: 300px;\n        margin-top: -75%;\n        left: 4%;\n    }\n    .h21{\n        margin-top: -155%;\n        left: 13%;\n    }\n    .h22{\n        width: 300px;\n        margin-top: -350%;\n        left: 4%;\n    }\n    .h42{\n        width: 300px;\n        margin-left: 0%;\n    }\n    .h23{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -350%;\n        left:4%;\n    }\n    .h43{\n        width: 300px;\n        margin-left: 0%;\n        font-size: 2.35vh;\n    }\n    .h24{\n        min-width: 250px;\n        max-width: 300px;\n        margin-top: -200%;\n        left: 10%;\n    }\n    .h44{\n        width: 300px;\n        font-size: 2.35vh;\n    }\n    .section1{\n        margin-bottom: 30%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
